import React from 'react'
import { Tooltip } from 'antd' ;
import { Button } from 'antd';

import x_grid_icon from './images/x_grid_icon.png' 
import y_grid_icon from './images/y_grid_icon.png' 
import z_grid_icon from './images/z_grid_icon.png' 
import magneto_icon from './images/magneto_icon.png' 
import bowshock_icon from './images/bowshock_icon.png' 
import orthogonal_icon from './images/orthogonal_icon.png' 
import perspective_icon from './images/perspective_icon.png' 

import { PERSP_CAMERA } from './Orbit_Display'
import { ORTHO_CAMERA } from './Orbit_Display' 
import { SIDE_BUTTON_STYLE } from './constants.js'
import { TT_BGCOLOR } from './constants.js'

import { V3DSpace } from './App.js'

class Icon_Display extends React.Component 
    {
    constructor (props)
        {
        super (props) ;

        this.render = this.render.bind (this) ;
        }

    render ()
        {
        const filter={filter: "invert(" + this.props.invert.toFixed() + "%)"} ;
        const background={background: "#404096"} ;

        let out ;

        if  (this.props.toggle)
            {
            out = <img  style={{...filter, ...background}}  
                        src={this.props.icon} className= "icon_image" 
                        alt="" 
                        /> ;
            }

        else
            {
            out = <img  style={filter}
                        src={this.props.icon} className= "icon_image"
                        alt="" 
                        /> ;
            }

        //out = <img  style={{background: "#404064"}} src={x_grid_icon} className= "icon_image" alt="" /> ;

        return (<>{out}</>) ;
        }
    }

class Function_Bar extends React.Component
    {
    constructor (props)
        {
        super (props) 

        this.state = {
            magneto_visible: false,
            bs_visible: false,
            xz_grid: V3DSpace.xz_grid_visible (),
            yz_grid: V3DSpace.yz_grid_visible (),
            xy_grid: V3DSpace.xy_grid_visible (),
            }

        this.toggle_bowshock = this.toggle_bowshock.bind (this)
        this.toggle_magnetopause = this.toggle_magnetopause.bind (this)
        this.toggle_xz_grid = this.toggle_xz_grid.bind (this)
        this.toggle_yz_grid = this.toggle_yz_grid.bind (this)
        this.toggle_xy_grid = this.toggle_xy_grid.bind (this)
        }

    toggle_magnetopause ()
        {
        const visible = ! this.state.magneto_visible

        V3DSpace.set_magnetopause_visible (visible)

        this.setState ({magneto_visible: visible}) 
        }

    toggle_bowshock ()
        {
        const visible = ! this.state.bs_visible

        V3DSpace.set_bowshock_visible (visible)

        this.setState ({bs_visible: visible}) 
        }

    toggle_xz_grid ()
        {
        V3DSpace.toggle_xz_grid_visible ()

        this.setState ({xz_grid: V3DSpace.xz_grid_visible ()})
        }

    toggle_yz_grid ()
        {
        V3DSpace.toggle_yz_grid_visible ()

        this.setState ({yz_grid: V3DSpace.yz_grid_visible ()})
        }

    toggle_xy_grid ()
        {
        V3DSpace.toggle_xy_grid_visible ()

        this.setState ({xy_grid: V3DSpace.xy_grid_visible ()})
        }

    render ()
        {    
        //const TT_BGCOLOR = "darkblue" ;
        //const filter={filter: "invert(" + this.props.invert.toFixed() + "%)"}

        const bowshock_button =
        <Tooltip    placement="left" 
            color={TT_BGCOLOR}
            title={`Display a mesh representing the magnetic bow shock 
                    relative to the Earth.`}>
            <Button
                size="small"
                type="ghost"
                onClick={this.toggle_bowshock} 
                style={SIDE_BUTTON_STYLE}
                >
                <Icon_Display icon={bowshock_icon} invert={this.props.invert} toggle={this.state.bs_visible} />                        
            </Button>
        </Tooltip> ;

        const mp_button =
        <Tooltip    placement="left" 
            color={TT_BGCOLOR}
            title="Display a mesh representing the magnetopause relative to the Earth.">
            <Button
                size="small"
                type="ghost"
                onClick={this.toggle_magnetopause} 
                style={SIDE_BUTTON_STYLE}
                >
                <Icon_Display icon={magneto_icon} invert={this.props.invert} toggle={this.state.magneto_visible} />                        
            </Button>
        </Tooltip> ;

        const yz_grid_button =
        <Tooltip    placement="left" 
            color={TT_BGCOLOR}
            title="Display a coordinate grid in the YZ plane perpendicular to the X axis.">
            <Button
                size="small"
                type="ghost"
                onClick={this.toggle_yz_grid} 
                style={SIDE_BUTTON_STYLE}
                >
                <Icon_Display icon={x_grid_icon} invert={this.props.invert} toggle={this.state.yz_grid} />
            </Button>
        </Tooltip> ;

        const xz_grid_button =
        <Tooltip    placement="left" 
            color={TT_BGCOLOR}
            title="Display a coordinate grid in the XZ plane perpendicular to the Y axis.">
            <Button
                size="small"
                type="ghost"
                onClick={this.toggle_xz_grid} 
                style={SIDE_BUTTON_STYLE}
                >
                <Icon_Display icon={y_grid_icon} invert={this.props.invert} toggle={this.state.xz_grid} />
            </Button>
        </Tooltip> ;

        const xy_grid_button =
        <Tooltip    placement="left" 
            color={TT_BGCOLOR}
            title="Display a coordinate grid in the XY plane perpendicular to the Z axis.">
            <Button
                size="small"
                type="ghost"
                onClick={this.toggle_xy_grid} 
                style={SIDE_BUTTON_STYLE}
                >
                <Icon_Display icon={z_grid_icon} invert={this.props.invert} toggle={this.state.xy_grid} />
            </Button>
        </Tooltip> ;

        const persp_button =
        <Tooltip    placement="left" 
            color={TT_BGCOLOR}
            title="Switch to the perspective camera.">
            <Button
                size="small"
                type="ghost"
                onClick={this.props.set_perspective} 
                style={SIDE_BUTTON_STYLE}
                >
                <Icon_Display icon={perspective_icon} invert={this.props.invert} toggle={this.props.camera_type === PERSP_CAMERA} />
            </Button>
        </Tooltip> ;

        const ortho_button =
        <Tooltip    placement="left" 
            color={TT_BGCOLOR}
            title="Swith to the orthographic camera.">
            <Button
                size="small"
                type="ghost"
                onClick={this.props.set_orthogonal} 
                style={SIDE_BUTTON_STYLE}
                >
                <Icon_Display icon={orthogonal_icon} invert={this.props.invert} toggle={this.props.camera_type === ORTHO_CAMERA} />
            </Button>
        </Tooltip> ;

        return (
            <div className="function_side_bar"> 
                {bowshock_button}
                {mp_button}
                {yz_grid_button}
                {xz_grid_button}
                {xy_grid_button}
                {persp_button}
                {ortho_button}
            </div>
            ) ;
        }
    }

export default Function_Bar
